export default __webpack_public_path__ + "static/media/189.bb11541a.jpg";